/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Label_Question_PluralInputs */

const es_components_ask_questions_label_question_plural = /** @type {(inputs: Components_Ask_Questions_Label_Question_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`preguntas`)
};

const en_components_ask_questions_label_question_plural = /** @type {(inputs: Components_Ask_Questions_Label_Question_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`questions`)
};

/**
* | output |
* | --- |
* | "questions" |
*
* @param {Components_Ask_Questions_Label_Question_PluralInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_label_question_plural = /** @type {((inputs?: Components_Ask_Questions_Label_Question_PluralInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Label_Question_PluralInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_label_question_plural(inputs)
	return en_components_ask_questions_label_question_plural(inputs)
});
export { components_ask_questions_label_question_plural as "components.ask_questions.label.question_plural" }